var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{key:_vm.month,staticClass:"dashboard-chart mt-2",attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"styles":_vm.styles}})}
var staticRenderFns = []

export { render, staticRenderFns }